import { z } from 'zod';

export const AdminModalTagsFormSchema = z.object({
  name: z.string().max(250),
});

export type AdminModalTagsFormValues = z.infer<typeof AdminModalTagsFormSchema>;
